import directive from './directives';

const importDirective = (Vue) => {
  /**
   * 权限指令
   * optaion={ }
   */
  Vue.directive('p', directive.permission);
};

export default importDirective;
